import { gql } from "@apollo/client";
import CompanySubscription from "~/lib/queries/fragments/CompanySubscription";
import StripeChargeFields from "~/lib/queries/fragments/StripeChargeFields";

export default gql`
  mutation ReactivateSubscription {
    reactivateSubscription {
      ...CompanySubscription
    }
  }

  ${CompanySubscription}
  ${StripeChargeFields}
`;
